import { render, staticRenderFns } from "./quotation-version.vue?vue&type=template&id=108609af&"
import script from "./quotation-version.vue?vue&type=script&lang=js&"
export * from "./quotation-version.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports